/* it7 Round 3 - small global behaviours. Loaded site-wide by the it7-r3-loader
   section; every block self-guards so it no-ops on pages that lack the markup.
   - AI-037: prev/next arrows + swipe on the PDP main gallery image.
   - AI-039: shorten the (otherwise truncated) header search placeholder on phones. */
(function () {
  'use strict';

  /* localized UI strings injected by layout/theme.liquid (window.it7Strings); English fallback. */
  var IT7S = window.it7Strings || {};
  function S(k, fb) { var v = IT7S[k]; return (v != null && v !== '') ? v : fb; }

  /* AI-037 - PDP main image: arrows + swipe, cycling the existing thumb rail. */
  function gallery() {
    var gal = document.querySelector('.it7-pdp .main-im');
    var main = document.getElementById('it7-main-img');
    if (!gal || !main) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('#it7-thumbs button'));
    if (thumbs.length < 2) return;            /* single image - nothing to navigate */
    if (gal.querySelector('.it7-gnav')) return; /* already wired */

    var i = 0;
    thumbs.forEach(function (t, idx) {
      if (t.classList.contains('on')) i = idx;
      t.addEventListener('click', function () { i = idx; }); /* keep index in sync with manual taps */
    });

    function go(n) {
      i = (n + thumbs.length) % thumbs.length;
      var t = thumbs[i];
      var src = t.getAttribute('data-src');
      if (src) main.src = src;
      thumbs.forEach(function (b) { b.classList.remove('on'); });
      t.classList.add('on');
      try { t.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); } catch (e) {}
    }

    function mk(cls, label, glyph) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'it7-gnav ' + cls;
      b.setAttribute('aria-label', label);
      b.textContent = glyph;
      return b;
    }
    var prev = mk('prev', S('prevImage','Previous image'), '‹');
    var next = mk('next', S('nextImage','Next image'), '›');
    prev.addEventListener('click', function (e) { e.preventDefault(); go(i - 1); });
    next.addEventListener('click', function (e) { e.preventDefault(); go(i + 1); });
    gal.appendChild(prev);
    gal.appendChild(next);

    var x0 = null;
    gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gal.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    }, { passive: true });
  }

  /* AI-039 - the desktop placeholder is long and truncates on phones; swap to a
     short one at mobile widths. */
  function searchPlaceholder() {
    var sq = document.getElementById('it7-sq');
    if (sq && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      sq.setAttribute('placeholder', S('searchShort','Search 1,000+ designers…'));
    }
  }


  /* AI-019 (PLP badges) - place New (random up to 6 of the first 20 eligible) and
     Trending (4 across 3 of the first 4 rows) on the PLP/search grid. Early access is
     server-rendered on the card (customer + within 24h). Skips the New Arrivals
     collection pages. Runs once per grid (decorative; not re-applied on filter). */
  function plpBadges() {
    var grid = document.querySelector('.it7-pgrid');
    if (!grid || grid.dataset.it7badged) return;
    if (/\/collections\/new-arrivals/i.test(location.pathname)) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.pc'));
    if (!cards.length) return;
    grid.dataset.it7badged = '1';
    function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
    /* one badge max per card. Early Access is server-rendered on the card already;
       the featured Editor's Pick (.hl) card is ineligible for any auto-badge. */
    function badged(c) { return c.classList.contains('hl') || !!c.querySelector('.it7-badge'); }
    function add(card, cls, label) {
      if (badged(card)) return;
      var im = card.querySelector('.im'); if (!im) return;
      var c = card.querySelector('.it7-badges');
      if (!c) { c = document.createElement('span'); c.className = 'it7-badges'; im.insertBefore(c, im.firstChild); }
      var s = document.createElement('span'); s.className = 'it7-badge ' + cls; s.textContent = label; c.appendChild(s);
    }
    /* priority EARLY ACCESS > TRENDING > NEW: Trending placed first (skipping EA
       cards), then New (skipping anything already badged) -> exactly one badge/card. */
    var gtc = getComputedStyle(grid).gridTemplateColumns;
    var cols = (gtc && gtc !== 'none') ? gtc.split(' ').filter(Boolean).length : 4;
    var rows = [];
    for (var r = 0; r < 4; r++) {
      var row = cards.slice(r * cols, (r + 1) * cols).filter(function (c) { return !badged(c); });
      if (row.length) rows.push(row);
    }
    var pool = [];
    shuffle(rows).slice(0, 3).forEach(function (r) { pool = pool.concat(r); });
    shuffle(pool).slice(0, 4).forEach(function (c) { add(c, 'it7-trending', S('trending','Trending')); });
    var elig = cards.slice(0, 20).filter(function (c) { return c.hasAttribute('data-new') && !badged(c); });
    shuffle(elig).slice(0, 6).forEach(function (c) { add(c, 'it7-new', S('newBadge','New')); });
  }

  /* "More Like This" — make "View all" the FINAL CARD in the carousel on ALL widths
     (Brett 2026-06-14, rev3). The standalone rail button is hidden (gated on
     .it7-mlt-hascard, so it stays as a fallback if JS doesn't run); a card-styled link
     is appended to the end of #it7-mlt-row, mirroring the button's search href (set by
     the MLT render script). The row populates lazily on scroll, so observe it. */
  function mltViewAll() {
    var sec = document.getElementById('it7-mlt');
    if (!sec) return;
    var row = document.getElementById('it7-mlt-row');
    var vab = sec.querySelector('[data-mlt-va]');
    if (!row || !vab) return;
    sec.classList.add('it7-mlt-hascard');
    var added = false;
    function addCard() {
      if (added || !row.children.length) return;
      added = true;
      var a = document.createElement('a');
      a.className = 'pc it7-mlt-vacard';
      a.href = vab.getAttribute('href') || '#';
      a.innerHTML = '<span class="vac">' + (vab.textContent || (S('viewAll','View all') + (document.documentElement.dir === 'rtl' ? ' ←' : ' →'))) + '</span>';
      row.appendChild(a);
    }
    if (row.children.length) addCard();
    else {
      var obs = new MutationObserver(function () { if (row.children.length) { addCard(); obs.disconnect(); } });
      obs.observe(row, { childList: true });
    }
  }

  /* Trust band rotation (Brett 2026-06-14): on phones the green trust strip shows one
     value prop at a time; cycle through them (CSS cross-fades via .it7-trust-on). */
  function trustRotate() {
    if (!(window.matchMedia && window.matchMedia('(max-width: 768px)').matches)) return;
    var wrap = document.querySelector('.it7-trust .it7-trust-in');
    if (!wrap) return;
    var items = wrap.children;
    if (items.length < 2) return;
    var i = 0;
    items[0].classList.add('it7-trust-on');
    setInterval(function () {
      items[i].classList.remove('it7-trust-on');                 /* fade the current one out (.5s) */
      var next = (i + 1) % items.length;
      setTimeout(function () { items[next].classList.add('it7-trust-on'); i = next; }, 540); /* then fade the next in — sequenced so the two lines never overlap */
    }, 2800);
  }

  /* AI-057 — sticky mobile Add-to-Bag bar. The long PDP scrolls the buy box off-screen;
     this fixed bottom bar (phones only) mirrors the main ATB's price + state and clicks it.
     (Mini-cart-on-add drawer is tracked separately — the base cart-drawer isn't wired to
     the it7 header, so it needs a dedicated integration pass.) */
  function pdpStickyAtb() {
    if (!(window.matchMedia && window.matchMedia('(max-width: 900px)').matches)) return;
    var atb = document.getElementById('it7-atb');
    var buy = atb && (atb.closest('.cta') || atb.closest('.buy'));
    if (!atb || !buy || document.querySelector('.it7-sticky-atb')) return;
    var bar = document.createElement('div');
    bar.className = 'it7-sticky-atb';
    bar.innerHTML = '<span class="sa-price"></span><button type="button" class="sa-btn">' + S('addToBag','Add to Bag') + '</button>';
    document.body.appendChild(bar);
    var saPrice = bar.querySelector('.sa-price'), saBtn = bar.querySelector('.sa-btn');
    function sync() {
      var txt = atb.textContent || '';
      saPrice.textContent = txt.indexOf('—') > -1 ? txt.split('—')[1].trim() : '';
      saBtn.disabled = atb.disabled && !atb.classList.contains('ok');
      if (atb.classList.contains('ok')) saBtn.textContent = S('addedToBag','Added to Bag') + ' ✓';
      else if (atb.classList.contains('err')) saBtn.textContent = S('tryAgain','Try again');
      else if (txt.indexOf('Adding') > -1 || txt.indexOf(S('adding','Adding…')) > -1) saBtn.textContent = S('adding','Adding…');
      else if (txt.indexOf('Sold') > -1 || txt.indexOf(S('soldOut','Sold out')) > -1) saBtn.textContent = S('soldOut','Sold out');
      else saBtn.textContent = S('addToBag','Add to Bag');
    }
    sync();
    new MutationObserver(sync).observe(atb, { childList: true, characterData: true, subtree: true, attributes: true });
    saBtn.addEventListener('click', function () { atb.click(); }); /* submits the form -> existing /cart/add flow */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { var on = !e.isIntersecting; bar.classList.toggle('show', on); document.body.classList.toggle('it7-atb-on', on); /* ITA2-903 */ }); }).observe(buy);
    } else { bar.classList.add('show'); document.body.classList.add('it7-atb-on'); }
  }

  /* AI-014 — restore the sticky "View results (N)" button in the mobile filter drawer
     (PLP + search). Injected once into .it7-sb; reads the live total from the grid's
     count element (#it7-total / #it7-count, updated by it7-plp-grid / it7-search-grid),
     and closes the drawer on tap. Hidden on desktop; pinned to the bottom of the open drawer. */
  function mobileFilterApply() {
    var sb = document.querySelector('.it7-sb');
    if (!sb || sb.querySelector('.it7-view-results')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'it7-view-results';
    function total() {
      var t = document.getElementById('it7-total');
      if (t && t.textContent.trim()) return t.textContent.trim();
      var c = document.getElementById('it7-count');
      if (c) { var m = c.textContent.match(/of\s*([\d,]+)/i); if (m) return m[1]; }
      return '';
    }
    function label() { var n = total(); btn.textContent = n ? (S('viewResults','View results') + ' (' + n + ')') : S('viewResults','View results'); }
    label();
    btn.addEventListener('click', function () { sb.classList.remove('open'); try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); } });
    sb.appendChild(btn);
    var watch = document.getElementById('it7-total') || document.getElementById('it7-count');
    if (watch && window.MutationObserver) new MutationObserver(label).observe(watch, { childList: true, characterData: true, subtree: true });
    /* ITA2-908 — mirror the drawer's open state onto <body> so the promo/chat stack
       (Gorgias / Klaviyo) can be hidden while the drawer is open (it7-r3.css), keeping
       the sticky "View results" button tappable. Watching the class itself covers every
       close path: the X (data-fclose), this button, and a backdrop tap. */
    function syncOpen() { document.body.classList.toggle('it7-filter-open', sb.classList.contains('open')); }
    if (window.MutationObserver) new MutationObserver(syncOpen).observe(sb, { attributes: true, attributeFilter: ['class'] });
    syncOpen();
  }

  /* AI-057 — lightweight it7 mini-cart (add-confirmation). Opens whenever the cart count
     INCREASES (an add), via the it7:cart-updated event the PDP + sticky ATB already fire.
     Self-contained: fetches /cart.js, renders items + subtotal + Checkout/View-bag CTAs.
     (The base cart-drawer isn't wired to the it7 header, so we don't depend on it.) */
  function miniCart() {
    if (document.querySelector('.it7-mc')) return;
    var wrap = document.createElement('div');
    wrap.className = 'it7-mc';
    wrap.innerHTML =
      '<div class="it7-mc-ov"></div>' +
      '<aside class="it7-mc-panel" role="dialog" aria-label="' + S('bag','Bag') + '" aria-modal="true">' +
      '<div class="it7-mc-hd"><span class="it7-mc-ttl">' + S('addedToYourBag','Added to your bag') + '</span><button class="it7-mc-x" type="button" aria-label="' + S('close','Close') + '">×</button></div>' +
      '<div class="it7-mc-body"></div>' +
      '<div class="it7-mc-ft"><div class="it7-mc-sub"><span>' + S('subtotal','Subtotal') + '</span><span class="it7-mc-subv"></span></div>' +
      '<a class="it7-mc-co" href="/checkout">' + S('checkout','Checkout') + '</a><a class="it7-mc-vb" href="' + (((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart') + '">' + S('viewBag','View bag') + '</a>' +
      '<button class="it7-mc-cont" type="button">' + S('continueShopping','Continue shopping') + '</button></div></aside>';
    document.body.appendChild(wrap);
    var body = wrap.querySelector('.it7-mc-body'), subv = wrap.querySelector('.it7-mc-subv');
    function close() { wrap.classList.remove('open'); document.body.classList.remove('it7-mc-lock'); }
    function open() { wrap.classList.add('open'); document.body.classList.add('it7-mc-lock'); }
    wrap.querySelector('.it7-mc-ov').addEventListener('click', close);
    wrap.querySelector('.it7-mc-x').addEventListener('click', close);
    wrap.querySelector('.it7-mc-cont').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
    function money(cents) { return (window.IT7FX && IT7FX.format) ? IT7FX.format(cents / 100) : ('$' + Math.round(cents / 100).toLocaleString('en-US')); }
    function render(c) {
      body.innerHTML = (c.items || []).map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        var opt = (it.options_with_values || []).map(function (o) { var v = o.value; return /^(tu|os|osfa|uni|unica|unique|onesize|one ?size|onesizefitsall|taglia ?unica)$/i.test(String(v).trim()) ? S('oneSize','One size') : v; }).filter(function (v) { return v && v !== 'Default Title'; }).join(' / ');
        return '<div class="it7-mc-it"><a href="' + esc(it.url) + '" class="it7-mc-im">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="it7-mc-meta"><div class="it7-mc-b">' + esc(it.vendor || '') + '</div>' +
          '<a href="' + esc(it.url) + '" class="it7-mc-n">' + esc(it.product_title || it.title) + '</a>' +
          (opt ? '<div class="it7-mc-opt">' + esc(opt) + '</div>' : '') +
          '<div class="it7-mc-pr">' + money(it.final_line_price) + '</div></div></div>';
      }).join('');
      subv.textContent = money(c.total_price);
    }
    var last = null;
    document.addEventListener('it7:cart-updated', function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        render(c);
        if (last !== null && c.item_count > last) open();   /* open only on an ADD */
        last = c.item_count;
      }).catch(function () {});
    });
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { if (last === null) last = c.item_count; }).catch(function () {});
  }

  /* AI-056 (cart) — normalize raw one-size codes ("TU"/"ONESIZE"/"OS"/…) to "One size" on
     the cart-page line items (the base main-cart section renders the variant title raw).
     Best-effort selectors; only replaces leaf elements whose exact text is a size code. */
  function normalizeCartSizes() {
    if (!/template-cart/.test(document.body.className) && location.pathname.indexOf('/cart') !== 0) return;
    var RX = /^(tu|os|osfa|uni|unica|unique|onesize|one ?size|onesizefitsall|taglia ?unica)$/i;
    document.querySelectorAll('[class*="cart-item"] dd, [class*="cart-item"] [class*="option"], cart-items dd, .cart-items dd, [class*="line-item"] dd, [class*="product-option"], [class*="variant"]').forEach(function (el) {
      if (el.children.length === 0 && RX.test((el.textContent || '').trim())) el.textContent = S('oneSize','One size');
    });
  }

  /* AI-060 — quick-add from PLP/search grid cards. A hover-revealed "Add to bag" on each
     #it7-grid card: one-size products add directly; multi-size reveal available-size pills.
     Variant data comes from /products/{handle}.js (same source hydrate() uses). On add it
     fires it7:cart-updated so the bespoke mini-cart opens. Desktop hover only — on touch the
     card stays a clean tap-through to the PDP (set via CSS @media (hover:none)). */
  function quickAdd() {
    var grid = document.getElementById('it7-grid');
    if (!grid) return;
    var ONE = /^(tu|os|osfa|uni|unica|unique|onesize|one ?size|onesizefitsall|taglia ?unica|default title)$/i;
    var cache = {};
    function qesc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
    /* Sort size pills smallest -> largest. Handles letter sizes (XXS..XXXXL), numeric
       (36, 36.5, 42), and shoe formats ("EU40/US10" -> ranks on the first number).
       Groups: letters before numbers before anything else; alpha as a last resort. */
    var SZ = { XXXS: -4, XXS: -3, XS: -2, S: -1, M: 0, L: 1, XL: 2, XXL: 3, XXXL: 4, XXXXL: 5 };
    function sizeRank(title) {
      var t = String(title == null ? '' : title).trim().toUpperCase().replace(/\s+/g, '');
      if (SZ.hasOwnProperty(t)) return [0, SZ[t], ''];
      var m = t.match(/\d+(?:[.,]\d+)?/);
      if (m) return [1, parseFloat(m[0].replace(',', '.')), ''];
      return [2, 0, t];
    }
    function bySize(a, b) {
      var ra = sizeRank(a.title), rb = sizeRank(b.title);
      if (ra[0] !== rb[0]) return ra[0] - rb[0];
      if (ra[0] === 2) return ra[2] < rb[2] ? -1 : (ra[2] > rb[2] ? 1 : 0);
      return ra[1] - rb[1];
    }
    function handleOf(card) {
      if (card.dataset.handle) return card.dataset.handle;
      var a = card.querySelector('a.im[href*="/products/"], a[href*="/products/"]');
      return a ? ((a.getAttribute('href') || '').split('?')[0].split('/products/')[1] || '') : '';
    }
    function isOneSize(vs) {
      /* "one size" = NO real size choice (sunglasses/bags), not merely a single variant.
         A shoe made in one size must still reveal that size pill on hover, never "Add to bag". */
      if (!vs || !vs.length) return true;
      return vs.every(function (v) { return ONE.test(String(v.title || '').trim()); });
    }
    function decorate(card) {
      if (card.querySelector('.it7-qa') || card.querySelector('.it7-qa-sizes')) return;
      var im = card.querySelector('.im');
      if (!im || !handleOf(card)) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'it7-qa';
      b.textContent = S('addToBagLc','Add to bag');
      im.appendChild(b);
    }
    /* ITA2-897 — reveal sizes for MULTI-SIZE (clothing) products on hover with NO latency.
       The SSR card embeds its variants in data-it7-qa, so hovering classifies + renders the
       size pills SYNCHRONOUSLY (no /products.js round-trip → no "Add to bag" flash, and every
       card behaves the same). ONE-SIZE products (bags/accessories) keep the direct Add-to-bag
       button. JS-built cards (filtered/search grids) have no attr and fall back to fetch.
       Desktop hover only — touch hides the control via CSS @media (hover:none). */
    function embedded(card) {
      var raw = card.getAttribute('data-it7-qa');
      if (!raw) return null;
      try {
        var arr = JSON.parse(raw);
        if (!arr || !arr.length) return null;
        return arr.map(function (v) { return { id: v.id, title: v.t, available: v.a }; });
      } catch (e) { return null; }
    }
    function revealSizes(card, vs) {
      if (isOneSize(vs)) return;                 /* one-size → keep the Add-to-bag button */
      var qb = card.querySelector('.it7-qa');
      if (qb && !qb.disabled && !qb.classList.contains('done')) openSizes(card, qb, vs, true);
    }
    function primeHover(card) {
      if (card.dataset.qaHover) return;
      card.dataset.qaHover = '1';
      card.addEventListener('mouseenter', function () {
        var vs = embedded(card);
        if (vs) { revealSizes(card, vs); return; }   /* instant — no fetch, no flash */
        var handle = handleOf(card);                  /* fallback: JS-built cards w/o embedded data (pre-hydrate hover) */
        if (!handle) return;
        var qb = card.querySelector('.it7-qa');       /* show "Loading sizes…" instead of a stale "Add to bag" while we fetch */
        if (qb && !qb.classList.contains('done')) qb.textContent = 'Loading sizes…';
        getProduct(handle).then(function (p) {
          var pv = p.variants || [];
          if (qb && !qb.classList.contains('done') && isOneSize(pv)) qb.textContent = 'Add to bag'; /* one-size keeps the button — restore its label */
          revealSizes(card, pv);
        }).catch(function () { if (qb) qb.textContent = 'Add to bag'; });
      });
    }
    function scan() { grid.querySelectorAll('.pc').forEach(function (card) { decorate(card); primeHover(card); }); }
    scan();
    new MutationObserver(scan).observe(grid, { childList: true });
    function getProduct(handle) {
      if (!cache[handle]) cache[handle] = fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + handle + '.js').then(function (r) { return r.json(); });
      return cache[handle];
    }
    function add(variantId, card, anchor) {
      anchor.textContent = S('adding','Adding…');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('it7:cart-updated'));
          var sizes = card.querySelector('.it7-qa-sizes');
          if (sizes) sizes.remove();
          var qb = card.querySelector('.it7-qa');
          if (!qb) { decorate(card); qb = card.querySelector('.it7-qa'); }
          if (qb) { qb.classList.add('done'); qb.textContent = S('added','Added') + ' ✓'; setTimeout(function () { if (qb.isConnected) { qb.classList.remove('done'); qb.textContent = S('addToBagLc','Add to bag'); } }, 2200); }
        })
        .catch(function () { anchor.textContent = S('tryAgain','Try again'); });
    }
    function openSizes(card, btn, variants, fromHover) {
      var avail = variants.filter(function (v) { return v.available; });
      if (!avail.length) {
        if (fromHover) return;                 /* ITA2-897: never mutate the card on hover */
        btn.disabled = true; btn.classList.add('soldout'); btn.textContent = S('soldOut','Sold out'); return;
      }
      /* click on a ONE-SIZE product → add straight away (one available size, or several
         that are all one-size tokens e.g. a 2-colour "One Size" bag — never render two
         indistinguishable "One size" pills). On HOVER never auto-add. */
      if (!fromHover && (avail.length === 1 || avail.every(function (v) { return ONE.test(String(v.title || '').trim()); }))) {
        add(avail[0].id, card, btn); return;
      }
      avail.sort(bySize); /* smallest -> largest, regardless of variant order in the feed */
      var im = card.querySelector('.im');
      var wrap = document.createElement('div');
      wrap.className = 'it7-qa-sizes';
      wrap.innerHTML = avail.map(function (v) {
        var label = ONE.test((v.title || '').trim()) ? S('oneSize','One size') : v.title;
        return '<button type="button" class="it7-qa-sz" data-vid="' + v.id + '">' + qesc(label) + '</button>';
      }).join('');
      btn.remove();
      im.appendChild(wrap);
    }
    grid.addEventListener('click', function (e) {
      var sz = e.target.closest('.it7-qa-sz');
      if (sz) { e.preventDefault(); e.stopPropagation(); add(parseInt(sz.dataset.vid, 10), sz.closest('.pc'), sz); return; }
      var qb = e.target.closest('.it7-qa');
      if (!qb || qb.disabled || qb.classList.contains('done')) return;
      e.preventDefault(); e.stopPropagation();
      var card = qb.closest('.pc');
      var vs = embedded(card);
      if (vs) { openSizes(card, qb, vs); return; }   /* instant: one-size adds, multi reveals pills — no fetch */
      var handle = handleOf(card);                    /* fallback: JS-built cards w/o embedded data */
      if (!handle) return;
      qb.textContent = S('loading','Loading…');
      getProduct(handle).then(function (p) { qb.textContent = S('addToBagLc','Add to bag'); openSizes(card, qb, p.variants || []); })
        .catch(function () { qb.textContent = S('tryAgain','Try again'); });
    });
  }

  function init() { gallery(); searchPlaceholder(); plpBadges(); mltViewAll(); trustRotate(); pdpStickyAtb(); mobileFilterApply(); miniCart(); normalizeCartSizes(); quickAdd(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

